var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ad-skeleton-text',{attrs:{"loading":_vm.underlying == null}},[(_vm.preHeadlineText)?_c('span',_vm._b({},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm.preHeadlineText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }